<template>
  <div>
    <el-row
      :gutter="24"
    >
      <el-col
        :lg="15"
        :md="15"
        :sm="24"
        :sx="24"
      >
        <iframe
          :src="`data:application/pdf;base64, ${document}`"
          width="100%"
          height="600px"
        />
      </el-col>
      <el-col
        :lg="9"
        :md="9"
        :sm="24"
        :xs="24"
      >
        <signature-pad
          v-if="activeTab === 'FibroidAuthObtainMedicalRecords'"
          :signature.sync="signature"
        />
        <el-divider>
          Or upload signed document
        </el-divider>
        <el-upload
          accept=".pdf"
          action="#"
          :auto-upload="false"
          drag
          :show-file-list="false"
          :on-change="onUploadSignedDocument"
        >
          <i class="el-icon-upload" />
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
        </el-upload>
      </el-col>
    </el-row>
    <el-row class="submit-btn">
      <el-button
        type="primary"
        @click="saveDocument"
      >
        Upload
      </el-button>
    </el-row>
  </div>
</template>

<script>
import SignaturePad from '../components/SignaturePad';

export default {
  name: 'SignDocuments',
  components: {
    SignaturePad
  },
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      }
    },
    activeTab: {
      type: String,
      default: 'profile'
    }
  },
  data: () => ({
    signature: '',
    document: undefined,
    numPages: 1,
    uploadedSignedDocument: false
  }),
  created () {
    this.getDocumentPreview();
  },
  watch: {
    signature: function (value) {
      this.uploadedSignedDocument = false;
      this.getDocumentPreview(value);
    }
  },
  methods: {
    getDocumentPreview (signature = null) {
      this.$emit('screenLoading', true);
      return this.$axios('/Patient/GetDocumentToPreviewFibroidAuthObtainMedicalRecords', {
        method: 'POST',
        data: {
          signature: signature,
          patientNumber: this.user.patientNumber
        },
        params: {
          token: this.$route.params.token
        }
      }).then((response) => {
        this.document = response.data.data;
        this.$emit('screenLoading', false);
      }).catch(() => {
        this.$emit('screenLoading', false);
      });
    },
    saveDocument () {
      if (this.signature || this.uploadedSignedDocument) {
        this.$emit('screenLoading', true);
        this.$axios('/Patient/StoreDocumentFibroidAuthObtainMedicalRecords', {
          method: 'PUT',
          data: {
            patientNumber: this.user.patientNumber,
            blobData: this.document,
            extension: 'pdf'
          },
          params: {
            token: this.$route.params.token
          }
        }).then(() => {
          this.$emit('screenLoading', false);
          this.$message.success('Document has been saved');
        }).catch((error) => {
          this.$emit('screenLoading', false);
          this.$message.error(error.response.data.errorMessage);
        });
      } else {
        this.$message.error('Sign or upload document');
      }
    },
    onUploadSignedDocument (file) {
      new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.raw);

        reader.onload = function () {
          resolve(reader.result);
        };
      }).then((base64) => {
        file.base64 = base64.split(';base64,')[1];
        this.document = file.base64;
        this.uploadedSignedDocument = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.submit-btn {
  display: flex;
  justify-content: center;
  margin-top: 22px;
}

.el-divider {
  &__text {
    width: max-content;
  }
}
</style>
